registerComponent("sections/home-history", function (component) {

});
